import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const dividerStyles = xcss({
	height: '0',
	width: '100%',
	borderTopWidth: 'border.width',
	borderTopStyle: 'solid',
	borderColor: 'color.border',
});

export const Divider = (): React.JSX.Element => {
	return <Box xcss={dividerStyles} />;
};
